import React from 'react';
import { SettingsProvider } from './contexts/SettingsContext';
import Varnakrama from './components/Varnakrama';
import './App.css';

function App() {
  return (
    <SettingsProvider>
      <Varnakrama />
    </SettingsProvider>
  );
}

export default App;
